import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
const SEV_COLOR = {
    info: '', warn: 'score-yellow', critical: 'score-red',
};
export default function NotifBell() {
    const [open, setOpen] = useState(false);
    const [unread, setUnread] = useState(0);
    const [list, setList] = useState([]);
    async function refresh() {
        try {
            const c = await api('/notifications/unread-count');
            setUnread(c.unread);
        }
        catch { /* not auth */ }
    }
    useEffect(() => {
        refresh();
        const id = setInterval(refresh, 30_000);
        return () => clearInterval(id);
    }, []);
    async function load() {
        setList(await api('/notifications?limit=20'));
    }
    useEffect(() => { if (open)
        load(); }, [open]);
    async function markRead(id) {
        await api(`/notifications/${id}/read`, { method: 'POST' });
        load();
        refresh();
    }
    async function readAll() {
        await api('/notifications/read-all', { method: 'POST' });
        load();
        refresh();
    }
    return (_jsxs("div", { style: { position: 'relative' }, children: [_jsxs("button", { onClick: () => setOpen(o => !o), style: { position: 'relative' }, children: ["\uD83D\uDD14", unread > 0 && (_jsx("span", { style: {
                            position: 'absolute', top: -4, right: -4, background: '#ef4444',
                            color: 'white', borderRadius: 10, padding: '0 6px', fontSize: 10,
                            fontWeight: 700, lineHeight: '16px',
                        }, children: unread > 99 ? '99+' : unread }))] }), open && (_jsxs("div", { style: {
                    position: 'absolute', top: 32, right: 0, width: 360, maxHeight: 480,
                    overflow: 'auto', background: '#0f172a', border: '1px solid #1f2937',
                    borderRadius: 6, padding: 8, zIndex: 1000,
                    boxShadow: '0 4px 24px rgba(0,0,0,.5)',
                }, children: [_jsxs("div", { style: { display: 'flex', justifyContent: 'space-between',
                            alignItems: 'center', padding: '4px 8px' }, children: [_jsx("strong", { children: "\u901A\u77E5" }), _jsx("button", { onClick: readAll, children: "\u5168\u90E8\u5DF2\u8B80" })] }), list.length === 0 && _jsx("div", { className: "muted", style: { padding: 16, textAlign: 'center' }, children: "\u6C92\u6709\u901A\u77E5" }), list.map(n => (_jsxs("div", { onClick: () => markRead(n.id), style: {
                            padding: 8, marginTop: 4, cursor: 'pointer',
                            background: n.read_at ? 'transparent' : '#1e293b',
                            borderRadius: 4, borderLeft: `3px solid ${n.severity === 'critical' ? '#ef4444'
                                : n.severity === 'warn' ? '#facc15' : '#3b82f6'}`,
                        }, children: [_jsxs("div", { style: { display: 'flex', justifyContent: 'space-between' }, children: [_jsx("strong", { style: { fontSize: 13 }, children: n.title }), _jsx("span", { className: `pill ${SEV_COLOR[n.severity]}`, style: { fontSize: 10 }, children: n.severity })] }), n.body && _jsx("div", { className: "muted", style: { fontSize: 12, marginTop: 2,
                                    whiteSpace: 'pre-wrap' }, children: n.body }), _jsxs("div", { className: "muted", style: { fontSize: 10, marginTop: 4 }, children: [n.created_at.slice(0, 16).replace('T', ' '), n.link && _jsx(Link, { to: n.link, style: { marginLeft: 8 }, onClick: () => setOpen(false), children: "\u67E5\u770B \u2192" })] })] }, n.id)))] }))] }));
}
